import { FC } from "react";
import { CompanyAnalysisIntelligence } from "../../../types/IntelligenceTypes";
import { CompetitorComarisions } from "./components/CompetitorComparisons";
import { EmergingAlternatives } from "./components/EmergingAlternatives";
import { HiddenCosts } from "./components/HiddenCosts";
import { InHouseFeasibilities } from "./components/InHouseFeasibility";
import { NegotiatedTerms } from "./components/NegotiatedTerms";
import { PricingModels } from "./components/PricingModels";
import { QualityCostTradeOffs } from "./components/QualityCostTradeOffs";

interface BenchmarkingPanelProps {
    analysis?: CompanyAnalysisIntelligence;
}

export const BenchmarkingPanel: FC<BenchmarkingPanelProps> = ({ analysis }) => {
    return (
        <div>
            <PricingModels data={analysis?.pricingModels} />
            <NegotiatedTerms data={analysis?.negotiatedTerms} style={{ marginTop: 16 }} />
            <HiddenCosts data={analysis?.hiddenCosts} style={{ marginTop: 16 }} />
            <EmergingAlternatives data={analysis?.emergingAlternatives} style={{ marginTop: 16 }} />
            <InHouseFeasibilities data={analysis?.inHouseFeasibilities} style={{ marginTop: 16 }} />
            <CompetitorComarisions
                data={analysis?.competitorComparisons}
                style={{ marginTop: 16 }}
            />
            <QualityCostTradeOffs data={analysis?.qualityCostTradeOffs} style={{ marginTop: 16 }} />
        </div>
    );
};
